var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-menubar p-component"},[_c('MenubarSub',{attrs:{"model":_vm.model,"root":true}}),(_vm.$slots.default)?_c('div',{staticClass:"p-menubar-custom"},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }